<template>
  <div id="app">
    <Navbar></Navbar>
    <loader v-if="loaderShow"></loader>
    <div class="row h-100" style="min-height: 100vh; max-width: 100vw;">
        <div class="col-lg-2 pr-0 sidebar">
            <ul class="w-100 pl-0 mt-4">
                <li class="listFont cursor-pointer py-3 mt-2" @click="state='automl'" :class="[state == 'automl' ? 'active': '']"><a href="#automl"> AutoML</a></li>
                <li class="listFont cursor-pointer py-3 mt-2" @click="state='visualize'" :class="[state == 'visualize' ? 'active': '']"><a href="#visualize"> AutoML EDA</a></li>
            </ul>
        </div>
        <div class="col-lg-10 p-5 text-left col-sm-12">
          <div class="automl" id="automl">
            <h1>Auto ML</h1>
            <p>Auto Ml , is nothing but automating the process of
             machine learning algorithms to satisfy the business problems.
              It allows non experts to explore the machine learning models
               and its predictions without any prior knowledge on it. </p>
            <h4 class="mt-3">This auto ml is purely for time-series forecasting </h4>

            <h3 class="mt-5">Targets of Auto ML</h3>
            <ol>
              <li>Data Preparation</li>
              <li>Data exploration and Exploratory data analysis</li>
              <li>Data Modelling with Hyper-parameter tuning</li>
              <li>Predictions of model for business needs</li>
            </ol>
            <h3 class="mt-5">Custom models:</h3>
            <ul>
              <li>
                <span class="listHead">Pre-processing</span>
                <ol>
                  <li>In pre-processing, anomalies are detected, missing values are handled, data-types
                     of feature variables are handled, outliers are detected and conversion is done into
                      hourly basis/daily basis as the requirements given. </li>
                  <li>The data-set is scaled or normalised, converted into supervised learning format and
                     reshaped for model training and forecasting.</li>
                </ol>
              </li>
              <li>
                <span class="listHead">Model Training</span>:
                <ol>
                  <li>
                    The model is trained, by splitting the data-set uploaded to train the dataset,
                     validation dataset and test dataset.
                  </li>
                  <li>Model is trained using a training dataset, validated across validation dataset
                     with appropriate optimization and error function and tested across the test dataset.
                  </li>
                  <li>
                    This trained model is used for future forecasting time.
                  </li>
                  <li><span class="listHead">Hyperparameter Tuning: </span>The model automatically tunes over the parameters such as optimizers, dropout ratio, epochs, activation functions, learning rate and so on and ends up with the model with best parameters.</li>
                </ol>
              </li>
            </ul>

            <h3 class="mt-5">Metrics to measure model performance:</h3>

            <p class=" ml-5 mt-3"><span class="listHead"><i class="far mx-3 fa-hand-point-right"></i>RMSE:</span>
            <ol class="ml-3">
              <li> Root Mean Square Error (RMSE) is the standard deviation of the residuals (prediction errors). Residuals are a measure of how far from the regression line data points are; RMSE is a measure of how to spread out these residuals are. In other words, it tells you how concentrated the data is around the line of best fit.</li>
              <li>The root-mean-squared error (RMSE) is a measure of how well your model performed. In a good model, the RMSE should be close for both your testing data and your training data.</li>
              <li>If the RMSE for your testing data is higher than the training data, there is a high chance that your model overfit. In other words, your model performed worse during testing than training.</li>
            </ol>
            </p>
            <div class="text-center"><img src="../../assets/formula.png" /></div>

            <p class=" ml-5 mt-3"><span class="listHead"><i class="far mx-3 fa-hand-point-right"></i>MAE: </span>
            <ol class="ml-3">
              <li> Mean absolute error (MAE) measures the average magnitude of the errors in a set of forecasts. It is the average over the verification sample of the absolute values of the differences between forecast and the corresponding observation. The MAE is a linear score which means that all the individual differences are weighted equally in the average.</li>
              <li>Lower values are better.</li>
            </ol>
            </p>
            <div class="text-center"><img src="../../assets/formula11.png" /></div>

            <p class="listHead">Note: <br />
                The RMSE will always be larger or equal to the MAE; Both the MAE and RMSE can range from 0 to ∞
                RMSE for train dataset and test dataset must be closed in the value range or almost similar
            </p>

            <h3>Requirements and How to :</h3>
            <ol>
              <li>There must be at least 1,000  rows and not more than 1,00,000 rows.</li>
              <li>The target feature must be present in the data-set.</li>
              <li>The user needs to upload only CSV files.</li>
              <li>The features in the dataset must be numeric and not categorical.</li>
              <li>Then, upload the dataset, select the DateTime column, feature variables to be pre-processed and frequency either hourly or daily conversion. Then proceed on clicking ‘Start Pre-processing’.</li>
              <li>Next, proceed with training by clicking ‘Start Training’ and select the required target column that needed to be trained for generating forecast models. Ensure that the chosen target column is pre-processed, else go back to pre-processing the data and come back.</li>
              <li>Once training completes,  download the trained model report to check the accuracy (RMSE and MSE)for analysing the model performance</li>
              <li>Next move on to forecasting, in the forecast there are two cases,
                <div class="mt-2"><span class="listHead"> Case 1 - Forecast by uploading file:</span>
                  <ul>
                    <li>Upload the recent history dataset of at least past 10 - 12days from the current/present-day/time</li>
                    <li>Next, select the required DateTime column, target feature, forecast time step i.e., how many days of forecast required and trained model</li>
                    <li>Ensure that the right model is chosen for the corresponding target feature that needs to be forecasted </li>
                  </ul>
                </div>
                <div class="mt-2">
                  <span class="listHead">Case 2 - Without file upload:</span>
                  <ul>
                    <li> Select the target feature and forecast time step i.e., how many days of forecast required and trained model</li>
                    <li>Ensure that right model that needs to be forecasted</li>
                  </ul>
                </div>
              </li>
              <li>
                 <span class="listHead">Note: </span>While forecasting, if there are no models then go back from the beginning i.e., pre-process and training. Proceed the above-mentioned procedure from start
              </li>
              <li>
                <span class="listHead">Note: </span>
                Remember,  if unsatisfied with model accuracy or forecasted value, start re-training the model or upload of current history data-set and proceed the above-mentioned procedure from start
              </li>
            </ol>
          </div>
          <div id="visualize" class="mt-5 pt-5">
            <h1 class="mt-5">AutoML EDA</h1>
            <p>Ambee AutoML EDA Report generates report for your data with a few clicks. It generates report for anomalies, missing values,
               outliers and gives descriptive statistics for your data within seconds.
            </p>

            <h3 class="mt-5">Used Terms:</h3>
            <ul>
              <li><span class="fontWeight">Numerical Variables:</span>
                <span>These variables usually measure something like height, weight, age, price etc.
                </span>
              </li>
              <li>
                <span class="fontWeight">Categorical Variables:</span>
                <span>These variables represent a category or group like gender, age group, type of flower etc.
                </span>
              </li>
              <li>
                <span class="fontWeight">Datetime Variables:</span>
                <span>These variables measure time like timestamp, year, month, hour, minute  etc.
                </span>
              </li>
              <li>
                <span class="fontWeight">Anomalies:</span>
                <span> These are values which should not be present such as a word or symbol inside a numerical column.</span>
              </li>
              <li>
                <span  class="fontWeight">Outliers:</span>
                <span>Outliers are readings or values which are very different from rest of the values.</span>
              </li>
              <li>
                <span  class="fontWeight">Missing values:</span>
                <span> Values which are not present in the dataset uploaded. They need to be handled either by dropping them or filling values.</span>
              </li>
              <li>
                <span  class="fontWeight">Descriptive statistics:</span>
                <span>Measures such as mean, median, standard deviation, variance, 25th,50th,75th percentile values etc.</span>
              </li>
            </ul>
            <h3 class="mt-5">Steps to proceed:</h3>
            <ol>
              <li>Click on Analyze Data
              <div><img src="../../assets/docs/Selection_010.png" class="my-3" style="width: 70%;" /></div>
              </li>
              <li>Enter Project Name
                <div class="text-center">
                  <img src="../../assets/docs/Selection_011.png" class="my-3" style="width: 53%" />
                </div>
              </li>
              <li>Upload your CSV file
                <div class="text-center">
                  <img src="../../assets/docs/Selection_009.png" class="my-3" style="width: 60%" />
                </div>
              </li>
              <li>Select Numerical, Categorical and Datetime features and click on Analyze
                <div class="text-center">
                  <img src="../../assets/docs/Selection_012.png" class="my-3" style="width: 80%" />
                </div>
              </li>
              <li>Click on Generate Report
                <div class="text-center">
                  <img src="../../assets/docs/Selection_007.png" class="my-3" style="width: 60%" />
                </div>
              </li>
              <li>Click on See Report
                <div class="text-center">
                  <img src="../../assets/docs/Selection_008.png" class="my-3" style="width: 60%" />
                </div>
              </li>
            </ol>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import Toasted from "vue-toasted";
import Vue from "vue";
import loader from "../loader";
import Navbar from "../navbar";

Vue.use(Toasted);

export default {
  name: "Documentation",
  props: {
    msg: String
  },
  components: {
    loader: loader,
    Navbar: Navbar,
  },
  data() {
    return {
        state: 'automl',
        loaderShow: false,
    };
  },
  watch: {
  },
  mounted() {
  },
  computed: {},
  methods: {
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.listHead {
  font-size: 18px;
  font-weight: 600;
}
@media screen and (max-width: 34em) {
  .sidebar {
    display: none;
  }
}
.listFont:hover{
    /* opacity: 0.7; */
    background: rgba(44, 45, 58, 1);
}
.sidebar:ul {
  list-style-type: none;
}
.cursor-pointer {
  cursor: pointer;
}
.sidebar{
    background: rgb(44, 45, 58, 0.95);
}
.active{
    /* opacity: 0.7; */
    background: rgba(44, 45, 58, 1);
}
.listFont{
  color: white;
  font-size: 1rem;
  font-weight: bolder;
}
.fontWeight {
  font-weight: 600;
}
a{
  color: white;
}
a:hover{
  color: white;
  text-decoration: none;
}
</style>